import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Component } from '../../../client';
import LocationLocaleEditor from '../../../components/locations/LocationLocaleEditor';
import { ActionButton, CancelButton } from '../../../components/ux/Buttons';
import { translate } from '../../../l10n';
class LocationLocaleSetter extends Component {
   constructor(props) {
      super(props);

      this.state = this.buildFromProps(props);
   }

   buildFromProps(props) {
      let currentLocation = props.currentLocation;

      return {
         location: currentLocation,
         defaultLocale: {
            languageCode: 'en',
            countryCode: 'ZA'
         },
         setLocale: true
      };
   }

   UNSAFE_componentWillReceiveProps(nextProps) {
      const current = this.state.location;
      const next = nextProps.currentLocation;

      if (!_.isEqual(current, next)) {
         this.setState(this.buildFromProps(nextProps));
      }
   }

   _onSave = () => {
      const { location } = this.state;
      this.props.onSet({ location });
   };

   _onCancel = (event, reason) => {
      if (!reason || reason != 'backdropClick') {
         this.props.onCancel();
      }
   };

   _onLocationChange = ({ location: newLocation, setLocale }) => {
      let { location } = this.state;

      location.languageCode = newLocation.languageCode;
      location.countryCode = newLocation.countryCode;

      this.setState({ location, setLocale });
   };

   render() {
      const { open } = this.props;
      const { location, setLocale, defaultLocale } = this.state;

      if (!open || !location) {
         return null;
      }

      return (
         <Fragment>
            <Dialog disableEscapeKeyDown className={'LocationLocaleSetter'} open={open} onClose={this._onCancel}>
               <DialogTitle>{`${translate('locations.locale.heading.settingLocale')} ${location.name}`}</DialogTitle>

               <DialogContent>
                  {!setLocale && <DialogContentText>{translate('locations.locale.info.inheritsLocale')}</DialogContentText>}
                  <LocationLocaleEditor
                     currentLocation={location}
                     setLocale={setLocale}
                     onChange={this._onLocationChange}
                     defaultLocale={defaultLocale}
                  />
               </DialogContent>
               <DialogActions className={'actions'}>
                  <ActionButton onClick={this._onSave}>{translate('locations.locale.button.save')}</ActionButton>
                  <CancelButton showOr={true} onClick={this._onCancel} />
               </DialogActions>
            </Dialog>
         </Fragment>
      );
   }
}

LocationLocaleSetter.defaultProps = {
   onSet: () => {},
   onCancel: () => {},
   readOnly: false,
   currentLocation: null
};

LocationLocaleSetter.propTypes = {
   onSet: PropTypes.func.isRequired,
   onCancel: PropTypes.func.isRequired,
   open: PropTypes.bool
};

export default LocationLocaleSetter;
